export default {
  website: {
    shoutoutSliderText1:
      "Regardez en streaming les matchs de la Ligue 1, de la Serie A, de la Bundesliga, de la Premier League, de la NFL, de la NBA, de la NCAA et bien d'autres encore !",
    'shoutout!': "C'est parti !",
    loveTheGame: 'AIMEZ LE JEU. FAITES-LE VÔTRE.',
    joinTheDedicated:
      'Rejoignez le réseau social dédié au sport - un écosystème plus fort grâce aux sponsors et aux partenaires.',
    aSportsCommunity: 'Un marché communautaire du sport.',
    athletesMonetize: 'Les athlètes monétisent leur marque.',
    fansConnectDirectly: 'Les fans sont en contact direct avec les athlètes.',
    ledByAthletes: 'DIRIGÉE PAR DES ATHLÈTES.',
    ledByFans: 'LED BY FANS.',
    ledBy: 'LED BY',
    'athletes.': 'ATHLETES.',
    'fans.': 'FANS.',
    goToApp: "Aller à l'application",
    logout: 'Déconnexion',
    amAnAthlete: 'Je suis un athlète',
    monetizeYourBrand: 'Monétisez votre marque en créant un univers unique avec vos fans.',
    amAFan: 'Je suis fan',
    connectDirectlyWith: "Connectez-vous directement avec vos athlètes préférés et d'autres fans.",
    athleteZone: 'ZONE ATHLÈTE',
    fanZone: 'FAN ZONE',
    ourAthletes: 'NOS ATHLÈTES',
    news: 'Actualités',
    ourStory: 'NOTRE HISTOIRE',
    sponsors: 'PARRAINS',
    contact: 'CONTACT',
    athleteFocus: "Priorité à l'athlète",
    calculator: 'Calculatrice',
    seeHowMuch: 'Voyez combien votre marque peut vous rapporter.',
    weAllPlay: 'NOUS JOUONS MIEUX ENSEMBLE.',
    everybody: 'TOUT LE MONDE',
    playsBetter: 'JOUE MIEUX',
    weAll: 'NOUS TOUS',
    playBetter: 'MIEUX JOUER',
    together: 'ENSEMBLE.',
    video: 'Vidéo',
    tiffanyVan: 'Tiffany Van Soest',
    goto: 'Aller à',
    athleteZoneSmall: "Zone de l'athlète",
    latestNews: 'DERNIÈRES NOUVELLES',
    ledByPartners: "SOUS L'ÉGIDE DES PARTENAIRES.",
    partnersAndSponsors: 'Partenaires et sponsors',
    ledByTeams: 'LED PAR ÉQUIPES.',
    seeOurWork: 'Voir notre travail avec ces athlètes de haut niveau',
    sportsCareer:
      "Les carrières sportives peuvent être courtes, mais vous avez acquis toute une vie d'expérience. Il est maintenant temps d'en récolter les fruits.,",
    buildAnOngoing: 'Construire un revenu continu et durable..,',
    takeControl: 'Prenez le contrôle de votre marque - et de votre avenir..,',
    signUpForFree:
      'Inscrivez-vous gratuitement pour calculer combien votre carrière peut continuer à vous donner,',
    'connect!': 'Connectez-vous !',
    unlimitedAccess:
      'Accès illimité à vos athlètes préférés. Créez votre propre réseau de héros sportifs !',
    'stream!': 'Stream !',
    streamGamesFrom:
      "Regardez en streaming les matchs de la Ligue 1, de la Serie A, de la Bundesliga, de la Premier League, de la NFL, de la NBA, de la NCAA et bien d'autres encore !",
    stayVisible: 'RESTEZ VISIBLE.',
    connectWithUs: 'Connectez-vous avec nous',
    newsletter: "Bulletin d'information",
    typeEmail: 'Saisissez l\'adresse électronique ici et appuyez sur la touche "Entrée".',
    typeAndEnter: 'Saisissez l\'adresse électronique ici et appuyez sur la touche "Entrée".',
    wedLoveTo: 'Nous serions ravis de vous entendre.',
    sendUsAMessage: 'Envoyer un message',
    notAnAthleteOrFan: "Vous n'êtes pas un athlète ou un fan ?",
    connectWithUsHere: 'Connectez-vous avec nous ici !',
    home: 'Accueil',
    fanZoneSmall: 'Zone de ventilation',
    ourStorySmall: 'Notre histoire',
    ourAthletesSmall: 'Nos athlètes',
    selectCountry: 'Sélectionner un pays',
    signUp: "S'inscrire",
    stopTheHate: 'Halte à la haine',
    termsAndConditions: "Conditions générales d'utilisation",
    privacyPolicy: 'Politique de confidentialité',
    playaz4playaz: '@playaz4playaz',
    allRigthsReserved: 'Tous droits réservés',
    led: 'LED',
    byTopAthletes: 'PAR DES ATHLÈTES DE HAUT NIVEAU',
    partners: 'Partenaires',
    investors: 'Investisseurs',
    attendees: 'Participants',
    date: 'Du 26 au 29 avril',
    location: 'Wesley Chapel, Floride',
    dontMiss: 'À NE PAS MANQUER',
    outOn: 'OUT ON',
    your: 'VOTRE',
    timeToShine: "L'HEURE EST VENUE DE BRILLER.",
    registerForCombine: "S'inscrire au Combine",
    registrationEnds: "FIN DE L'INSCRIPTION",
    days: 'Jours',
    hours: 'Heures',
    minutes: 'Procès-verbal',
    seconds: 'Secondes',
    ourPartners: 'NOS PARTENAIRES.',
    enjoyTheseMembership: "Profitez de ces caractéristiques étonnantes de l'adhésion",
    sportUnites: 'UNITÉS SPORTIVES.',
    noDivide: 'NO DIVIDE.',
    videosArticles: 'Vidéos, articles et interviews de stars du sport',
    instantMessaging: 'Messagerie instantanée avec vos athlètes préférés',
    discountOnEvent: "Réductions sur les billets d'événements et les produits dérivés",
    behindTheScenes: 'Accès aux coulisses du monde du sport',
    experienceSport: "VIVRE LE SPORT COMME VOUS L'AIMEZ.",
    theOnlySportsApp:
      "La seule application sportive qui vous permet d'être en contact direct avec vos athlètes préférés - en temps réel !",
    buildYourOwnWorld:
      'Construisez votre propre monde en vous connectant directement avec les athlètes - les vrais.',
    chooseTheFeatures: 'Choisissez les caractéristiques que vous aimez.',
    interactWithAthletes: 'Interagissez avec les athlètes et laissez-vous inspirer !',
    sendAShoutout:
      'Envoyez un message à votre athlète ou à votre équipe juste avant - ou même pendant - le match !',
    fanLife: '#FANLIFE',
    highlights: 'Points forts',
    recentArticles: 'Articles récents',
    p4pxIra: 'p4p x Ira Brown',
    uploadedDate: 'Téléchargé le 28 février 2022',
    youMightAlso: 'Vous pourriez aussi aimer...',
    'subscribe!': 'Abonnez-vous !',
    getContent:
      ' Obtenez du contenu et du streaming pour votre sport préféré - ou tous les sports sur playaz4playaz !',
    'vipConnects!': 'VIP Connects !',
    '1-to-1connections':
      'Des connexions 1 à 1 avec votre athlète préféré, que ce soit virtuellement ou en personne !',
    watch: "Regarder : l'histoire de p4p",
    caseStudies: 'Études de cas',
    aboutHenrySeals:
      "Diplômé de l'Université de Harvard, Henry est un dirigeant expérimenté. Actuellement, Henry est le CHRO de Zaiko, une startup basée au Japon qui aide les créateurs à engager leurs fans par le biais de l'engagement numérique et hybride.  Il est également le premier commissaire aux droits de l'homme né à l'étranger et le fondateur de la Legacy Foundation Japan. \u000bEn tant que CHRO pour Paidy, il a aidé l'entreprise à devenir l'une des seules licornes du Japon (entreprises évaluées à un milliard de dollars) et à être cotée en bourse en 2021.\nIl a également occupé des postes de direction dans le domaine des ressources humaines pour Philip Morris International, AIG et NN.\n\n",
    aboutHoustonRoss:
      "Houston a des années d'expérience dans la direction d'organisations mondiales pour préparer l'avenir, moderniser les opérations et l'infrastructure, et développer des équipes pour atteindre un haut niveau de performance.  Plus récemment, Houston a été le directeur technique de la licorne japonaise BNPL Paidy, menant l'organisation vers une sortie publique réussie.\nLeader mondial, Houston a occupé le poste de directeur technique pour des organisations financières mondiales telles que AXA Life, ING et NN.  \nPassionné de sport, il souhaite mettre à profit son expérience en matière de technologie, de finance et d'excellence opérationnelle pour faire de P4P un leader mondial.",
    aboutJuliusGoldsmith:
      "Julius est un juriste qui a plus de 20 ans d'expérience à Wall Street dans les domaines du développement commercial, du développement de nouveaux produits et des transactions transfrontalières. Julius a travaillé à New York, Londres, Singapour et Tokyo, où il a acquis une vaste expérience dans de multiples disciplines, notamment le développement commercial, la finance, les questions juridiques et fiscales.  Julius est membre des conseillers du doyen du Silberman College of Business de l'université Fairleigh Dickinson (son alma mater) et est également titulaire d'un CPA.  ",
    aboutMarcelVanDruten:
      "Marcel Van Druten est un professionnel chevronné qui a fait ses preuves dans des environnements technologiques mondiaux. Né et élevé à Amsterdam, aux Pays-Bas, Marcel a joué au football jusqu'à l'âge de 21 ans en tant que défenseur intrépide dans les plus hautes ligues amateurs de plusieurs clubs de football. \nGrâce à sa grande expertise en matière de marketing et de publicité, Marcel a aidé des marques internationales à élaborer et à mettre en œuvre des programmes et des initiatives visant à accroître les revenus et à promouvoir la notoriété de la marque. Polyglotte (anglais, néerlandais et allemand) et passionné d'arts martiaux, de golf et de Formule 1, Marcel aide P4P à devenir la meilleure application sportive au monde.\n",
    aboutMichaelAJacobs:
      "Michael est un cadre supérieur et un professionnel du droit avec un bilan diversifié de succès dans l'amélioration des opérations multi-sites grâce à un engagement communautaire supérieur ; ressources humaines; relations de travail et relations avec les employés et expérience juridique. Actuellement, il est maître de conférences à l'Université de New York, à la Robert F. Wagner Graduate School of Public Service et professeur associé adjoint à la City University of New York, School of Professional Studies. Michael était auparavant membre auxiliaire du corps professoral du Campus mondial de l'Université du Maryland (anciennement, University of Maryland University College) et de la Howard University School of Law.\n",
    aboutMichaelJackson:
      "Diplômé de l'Université de Columbia, Michael est un gestionnaire de produits expérimenté et l'ancien responsable régional de la livraison pour des organisations mondiales de gestion d'actifs et de patrimoine.  Il possède des années d'expérience dans la mise en œuvre de projets mondiaux visant à améliorer l'efficacité opérationnelle et la fourniture de services et de produits. \n \n",
    sponsorsSmall: 'Parrains',
    becomeASponsor: 'DEVENIR UN SPONSOR DU P4P',
    content1: 'Lorem ipsum...',
    content2: 'Lorem ipsum...',
    ourTeams: 'NOS ÉQUIPES.',
    paymentDetails: 'LES MODALITÉS DE PAIEMENT',
    cancelWithin30Days:
      'Annulez dans les 30 jours et votre carte ne sera pas débitée. Vous pourrez toujours accéder aux fonctions de base.',
    cardNumber: 'NUMÉRO DE CARTE',
    expiry: 'EXPIRATION',
    cvc: 'CVC',
    illDoItLater: 'Je le ferai plus tard',
    submit: '',
    athleteInformation: "INFORMATIONS SUR L'ATHLÈTE",
    contactInformation: 'INFORMATIONS DE CONTACT',
    otherInformation: 'AUTRES INFORMATIONS',
    dateOfBirth: 'DATE DE NAISSANCE',
    year: 'Année',
    month: 'Mois',
    day: 'Jour',
    socialNetworks: 'LES RÉSEAUX SOCIAUX',
    Instagram: 'Instagram',
    facebook: 'Facebook',
    twitter: 'Twitter',
    uploadHeadshot: "Télécharger une photo de tête ou une photo d'action de basket-ball",
    phoneNumber: 'Numéro de téléphone',
    sport: 'Le sport',
    linkInstagram: 'Lien vers votre profil Instagram',
    linkFacebook: 'Lien vers votre profil Facebook',
    linkTwitter: 'Lien vers votre profil Twiiter',
    athleteSignUp: 'athlèteS’inscrire',
    thankYou: 'MERCI',
    youWillBeSent: 'Un courriel de confirmation vous sera envoyé dans les plus brefs délais.',
    getTheApp: "TÉLÉCHARGEZ L'APPLICATION !",
    or: 'OU',
    continueOnWebsite: 'Continuer sur le site web',
    welcome: 'BIENVENUE !',
    '30dayFull': 'Accès complet pendant 30 jours !',
    enjoyTheseAmazing: 'Profitez de ces fonctionnalités étonnantes gratuitement, sans conditions !',
    yesGiveMe: 'Oui, donnez-moi un accès gratuit !',
    noThanksKeep: 'Non merci, restez basique',
    letsWorkTogether:
      'Travaillons ensemble ! Veuillez remplir vos coordonnées et nous vous contacterons.',
    yourDetails: 'VOS DÉTAILS',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    emailAddress: 'Adresse électronique',
    companyInformation: "INFORMATIONS SUR L'ENTREPRISE",
    companyName: "Nom de l'entreprise",
    companyWebsite: "Site web de l'entreprise",
    login: 'Connexion',
    getApp: "obtenir l'application",
    letsTalk: 'Parlons-en',
    sponsor: 'Parrainage',
    useTheApp: "Utiliser l'APP",
    messageSent: 'Message envoyé avec succès.',
    invalidEmail: 'Email non valide.',
    addedToNewsletter: "L'email a été ajouté avec succès à la lettre d'information.",
    recently: 'Récemment',
    aboutAyannaColeman: 'Lorem ipsum...'
  }
};
